import React, {useState, useEffect} from 'react'
import { useSelector } from "react-redux";

import Header from "../../components/Header/Header";
import FarmingItem from '../../components/Home/FarmingItem/FarmingItem'

import './Home.scss'


export default function Home() {
    const { allPools } = useSelector(({ pools }) =>  pools);
    const { userInfo } = useSelector(({ user }) =>  user);
    const [filterAllPosts, setFilterAllPosts] = useState([])
    const [switchFilter, setSwitchFilter] = useState(true)

    useEffect(() => {
        if (switchFilter){
            setFilterAllPosts(allPools.filter( post => post.available === 1 && post.end_time * 1000 > Date.now()))
        }else{
            setFilterAllPosts(allPools.filter( post => post.available === 1 && post.end_time * 1000 < Date.now()))
        }
    }, [switchFilter, setFilterAllPosts, allPools])

    return (
        <>
            <Header title={'My Pool'} link={'/mypool'} setSwitchFilter={setSwitchFilter} switchFilter={switchFilter}  showFilterPool={true} />
            <div className={'farming-content'}>
                { filterAllPosts.map( item =>
                    <FarmingItem
                        enable={'STAKING'}
                        collect={'COLLECT'}
                        key={item.pool_id}
                        pool={item.pool_id}
                        title={'POOL'}
                        owner={item.pool_owner}
                        staked={item.total_staked_tokens}
                        minStake={item.min_stake_amount}
                        stakingContract={item.staked_tokens_contract}
                        finishTimestamp={item.end_time}
                        startTimestamp={item.start_time}
                        reward={item.reward}
                        available={item.available}
                        userInfo={userInfo}
                        showIcons={false}
                    />
                ) }
            </div>
        </>
    );
}